export const Cover = () => {
  return <div className="cover-wrapper"></div>
}
